module.exports = __webpack_public_path__ + "img/smartEnergy-xs.8760519b.jpg";